export const BestOf2025Phases = {
  DRAFT: 'draft',
  SUBMISSION: 'submission',
  SUBMISSION_UNAVAILABLE: 'submission_unavailable',
  SUBMISSION_ENDED: 'submission_ended',
  SUBMISSION_RESOURCES: 'submission_resources',

  PHASE_ONE_VOTING: 'phase_one_voting',
  PHASE_ONE_VOTING_RESOURCES: 'phase_one_voting_resources',
  PHASE_ONE_VOTING_ENDED: 'phase_one_voting_ended',
  PHASE_ONE_VOTING_TIEBREAK: 'phase_one_tiebreak',
  PHASE_ONE_WINNERS: 'phase_one_results_announcement',
  PHASE_ONE_SINGLE_SUBMISSION: 'phase_one_single_submission',

  PHASE_TWO_VOTING: 'phase_two_voting',
  PHASE_TWO_VOTING_RESOURCES: 'phase_two_voting_resources',
  PHASE_TWO_VOTING_ENDED: 'phase_two_voting_ended',
  RESULTS_PUBLISHED: 'results_published',
} as const;

export type BestOf2025Phase = (typeof BestOf2025Phases)[keyof typeof BestOf2025Phases];
